import { INIT, SUCCESS, LOADING, ERROR } from "../../../utils/constants";
import {
  GET_FORECAST_BILL_AZURE,
  GET_FORECAST_BILL_AZURE_SUCCESS,
  GET_FORECAST_BILL_AZURE_ERROR,
  GET_DAILY_FORECAST_BILL_AZURE,
  GET_DAILY_FORECAST_BILL_AZURE_SUCCESS,
  GET_DAILY_FORECAST_BILL_AZURE_ERROR,
  GET_RESOURCEGROUP_FORECAST_BILL_AZURE,
  GET_RESOURCEGROUP_DAILY_FORECAST_BILL_AZURE_SUCCESS,
  GET_RESOURCEGROUP_DAILY_FORECAST_BILL_AZURE_ERROR,
  GET_LOCATION_FORECAST_BILL_AZURE,
  GET_LOCATION_DAILY_FORECAST_BILL_AZURE_SUCCESS,
  GET_LOCATION_DAILY_FORECAST_BILL_AZURE_ERROR,
} from "./constant";

const initialState = {
  phase1: INIT,
  azureForecastBillList: null,
  error: null,
};

const initialDailyState = {
  phase2: INIT,
  azureDailyForecastBillList: null,
  error: null,
};

const initialResourceGroupState = {
  phase3: INIT,
  azureResourceGroupForecastBillList: null,
  error: null,
};

const initialLocationState = {
  phase4: INIT,
  azureLocationForecastBillList: null,
  error: null,
};

/**
 * User Reducer
 * @param {Object} state
 * @param {Object} action
 */

export function AzureForecastBillStore(state = initialState, action) {
  switch (action.type) {
    case GET_LOCATION_FORECAST_BILL_AZURE:
      return {
        ...state,
        phase1: LOADING,
      };
    case GET_FORECAST_BILL_AZURE_SUCCESS:
      return {
        ...state,
        phase1: SUCCESS,
        azureForecastBillList: action.data,
        error: null,
      };
    case GET_FORECAST_BILL_AZURE_ERROR:
      return { ...state, phase1: ERROR, error: action.error };

    default:
      return state;
  }
}

export function AzureLocationForecastBillStore(
  state = initialLocationState,
  action
) {
  switch (action.type) {
    case GET_FORECAST_BILL_AZURE:
      return {
        ...state,
        phase4: LOADING,
      };
    case GET_LOCATION_DAILY_FORECAST_BILL_AZURE_SUCCESS:
      return {
        ...state,
        phase4: SUCCESS,
        azureLocationForecastBillList: action.data,
        error: null,
      };
    case GET_LOCATION_DAILY_FORECAST_BILL_AZURE_ERROR:
      return { ...state, phase4: ERROR, error: action.error };

    default:
      return state;
  }
}

export function AzureDailyForecastBillStore(state = initialDailyState, action) {
  switch (action.type) {
    case GET_DAILY_FORECAST_BILL_AZURE:
      return {
        ...state,
        phase2: LOADING,
      };
    case GET_DAILY_FORECAST_BILL_AZURE_SUCCESS:
      return {
        ...state,
        phase2: SUCCESS,
        azureDailyForecastBillList: action.data,
        error: null,
      };
    case GET_DAILY_FORECAST_BILL_AZURE_ERROR:
      return { ...state, phase2: ERROR, error: action.error };

    default:
      return state;
  }
}

export function AzureResourcegroupForecastBillStore(
  state = initialResourceGroupState,
  action
) {
  switch (action.type) {
    case GET_RESOURCEGROUP_FORECAST_BILL_AZURE:
      return {
        ...state,
        phase3: LOADING,
      };
    case GET_RESOURCEGROUP_DAILY_FORECAST_BILL_AZURE_SUCCESS:
      return {
        ...state,
        phase3: SUCCESS,
        azureResourceGroupForecastBillList: action.data,
        error: null,
      };
    case GET_RESOURCEGROUP_DAILY_FORECAST_BILL_AZURE_ERROR:
      return { ...state, phase3: ERROR, error: action.error };

    default:
      return state;
  }
}
